"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ibanFormatter;
var _validateIban = _interopRequireDefault(require("./validateIban"));
function ibanFormatter(iban) {
  var seperator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
  if (!(0, _validateIban.default)(iban)) {
    return false;
  }
  var EVERY_FOUR_CHARS = /(.{4})(?!$)/g;
  return iban.replace(EVERY_FOUR_CHARS, '$1' + seperator);
}